export const ORDER_PRODUCT_FILE_PUSH = 'order-product-file.push';
export const ORDER_PRODUCT_FILE_REMOVE = 'order-product-file.remove';
